export default __webpack_public_path__ + "static/media/wallpaper_bg1.ce548990.png";